import { atom } from 'jotai';
export const $WebUser = atom({
    webId: '',
});
//# sourceMappingURL=web-user.js.map